import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '90%',
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  txTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  card: {
    backgroundColor: theme.palette.primary.main,
    padding: '8px 18px 8px 18px',
    color: 'white',
    display: 'flex',
    height: 100,
    borderRadius: 5,
    alignItems: 'center',
  },
  txPackageName: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  txDesc: {
    fontSize: 14,
  },
  btnChangePackage: {
    alignSelf: 'flex-start',
    margin: '8px 0px 8px 0px',
    fontSize: 14,
  },
  txDetails: {
    fontSize: 14,
  },
  txNotes: {
    fontSize: 14,
    color: 'grey',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  txTotalPrice: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'black',
  },
  txPrice: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0AE013',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogContent: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 20,
  },
  descBox: {
    marginTop: 10,
    marginBottom: 10,
  },

}))

export default useStyles
